import React, { useState } from 'react';
import { WordList } from './WordList';
import { faAdd, faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../buttons/IconButton';
import useApiCall from 'contexts/ApiCall';
import aiService from 'services/aiService';

type WordAdderProps = {
  words: string[];
  generatePrompt?: string;
  onAddWord: (word: string) => void;
  onDeleteWord: (word: string) => void;
};

const WordAdder: React.FC<WordAdderProps> = ({
  words,
  generatePrompt,
  onAddWord,
  onDeleteWord,
}) => {
  const [nextWord, setNextWord] = useState<string>('');
  const makeApiCall = useApiCall();

  const handleAddWord = () => {
    setNextWord('');
    onAddWord(nextWord);
  };

  const handleGenerateWords = () => {
    if (!generatePrompt) return;

    makeApiCall(aiService.generateRelatedWords, generatePrompt)
      .then((respWords) => respWords.map((w: string) => onAddWord(w)))
      .catch((error) => alert(error));
  };

  return (
    <>
      <div className="row stretch">
        <input
          type="text"
          placeholder="Enter a word..."
          value={nextWord}
          onChange={(event) => setNextWord(event.target.value)}
        />
        <IconButton type="go" icon={faAdd} onClick={handleAddWord} size="lg" />
        {generatePrompt && (
          <IconButton
            type="edit"
            icon={faMagicWandSparkles}
            onClick={handleGenerateWords}
            size="lg"
          />
        )}
      </div>
      <WordList words={Array.from(words)} onDeleteWord={onDeleteWord} />
    </>
  );
};

export default WordAdder;
